import edgeCommon from '../common';

let sites = (function () {
    let initSites = function () {
        $(document).on("click", ".add-sites", function () {
            let id = $(this).data("id");
            let name = $(this).data("name");
            Swal.fire({
                title: "Are you sure?",
                html: "You want to add <strong>" + name + "</strong> site",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Yes, add it!",
                closeOnClickOutside: false,
                allowOutsideClick: false,
            }).then((result) => {
                if (result.isConfirmed) {
                    $(".loading").removeClass("d-none");
                    $.ajax({
                        url: baseUrl + "/user-sites/store",
                        type: "POST",
                        dataType: "JSON",
                        data: { id: id, },
                        success: function (response) {
                            $(".loading").addClass("d-none");
                            if (response.status == "success") {
                                edgeCommon.swalSuccess(response.message).then(() => {
                                    window.location.reload();
                                });
                            }
                        },
                        error: function (xhr) {
                            $(".loading").addClass("d-none");
                            let err = eval("(" + xhr.responseText + ")");
                            edgeCommon.swalError(err.message);
                        },
                    });
                }
            });
        });

        $(document).on("click", ".remove-sites", function () {
            let id = $(this).data("id");
            let name = $(this).data("name");
            Swal.fire({
                title: "Are you sure?",
                html: "You want send request for remove <strong>" + name + "</strong> site",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Yes, remove it!",
                closeOnClickOutside: false,
                allowOutsideClick: false,
            }).then((result) => {
                if (result.isConfirmed) {
                    $(".loading").removeClass("d-none");
                    $.ajax({
                        url: baseUrl + "/user-sites/request-for-remove-site",
                        type: "POST",
                        dataType: "JSON",
                        data: { id: id, },
                        success: function (response) {
                            $(".loading").addClass("d-none");
                            if (response.status == "success") {
                                edgeCommon.swalSuccess(response.message).then(() => {
                                    window.location.reload();
                                });
                            }
                        },
                        error: function (xhr) {
                            $(".loading").addClass("d-none");
                            let err = eval("(" + xhr.responseText + ")");
                            edgeCommon.swalError(err.message);
                        },
                    });
                }
            });
        });

        
        $(document).on("click", ".request-for-set-primary", function () {
            let id = $(this).data("id");
            let name = $(this).data("name");
            Swal.fire({
                title: "Are you sure?",
                html: "You want send request to set <strong>" + name + "</strong> site as primary site",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Yes, do it!",
                closeOnClickOutside: false,
                allowOutsideClick: false,
            }).then((result) => {
                if (result.isConfirmed) {
                    $(".loading").removeClass("d-none");
                    $.ajax({
                        url: baseUrl + "/user-sites/request-for-set-primary-site",
                        type: "POST",
                        dataType: "JSON",
                        data: { id: id, },
                        success: function (response) {
                            $(".loading").addClass("d-none");
                            if (response.status == "success") {
                                edgeCommon.swalSuccess(response.message).then(() => {
                                    window.location.reload();
                                });
                            }
                        },
                        error: function (xhr) {
                            $(".loading").addClass("d-none");
                            let err = eval("(" + xhr.responseText + ")");
                            edgeCommon.swalError(err.message);
                        },
                    });
                }
            });
        });

        $(document).on("click", ".default-site", function () {
            let id = $(this).data("id");
            let name = $(this).data("name");
            Swal.fire({
                title: "Are you sure?",
                html: "You want to set <strong>" + name + "</strong> site as default site",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Yes, add it!",
                closeOnClickOutside: false,
                allowOutsideClick: false,
            }).then((result) => {
                if (result.isConfirmed) {
                    $(".loading").removeClass("d-none");
                    $.ajax({
                        url: baseUrl + "/user-sites/setDefault",
                        type: "POST",
                        dataType: "JSON",
                        data: { id: id, },
                        success: function (response) {
                            $(".loading").addClass("d-none");
                            if (response.status == "success") {
                                edgeCommon.swalSuccess(response.message).then(() => {
                                    window.location.reload();
                                });
                            }
                        },
                        error: function (xhr) {
                            $(".loading").addClass("d-none");
                            let err = eval("(" + xhr.responseText + ")");
                            edgeCommon.swalError(err.message);
                        },
                    });
                } else {
                    window.location.reload();
                }
            });
        });

        
        $(document).on("click", ".sessionSite", function () {
            let id = $(this).data("id");
            $.ajax({
                url: baseUrl + "/user-sites/setSiteSession",
                type: "POST",
                dataType: "JSON",
                data: { id: id, },
                success: function () {
                    $(".loading").addClass("d-none");
                    window.location.reload();
                },
                error: function (xhr) {
                    $(".loading").addClass("d-none");
                    let err = eval("(" + xhr.responseText + ")");
                    edgeCommon.swalError(err.message);
                },
            });
        });

        $(document).on("click", ".approve-request-remove", function () {
            let userId = $(this).data("userid");
            let siteId = $(this).data("siteid");
            Swal.fire({
                title: "Are you sure?",
                html: "You want to approve site remove request",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Yes, approve it!",
                closeOnClickOutside: false,
                allowOutsideClick: false,
            }).then((result) => {
                if (result.isConfirmed) {
                    $(".loading").removeClass("d-none");
                    $.ajax({
                        url: baseUrl + "/admin/users/approve-remove-site-request",
                        type: "POST",
                        dataType: "JSON",
                        data: { user_id : userId, site_id : siteId},
                        success: function (response) {
                            $(".loading").addClass("d-none");
                            if (response.status == "success") {
                                edgeCommon.swalSuccess(response.message).then(() => {
                                    window.location.reload();
                                });
                            }
                        },
                        error: function (xhr) {
                            $(".loading").addClass("d-none");
                            let err = eval("(" + xhr.responseText + ")");
                            edgeCommon.swalError(err.message);
                        },
                    });
                }
            });
        });

        $(document).on("click", ".approve-request-set-site-primary", function () {
            let userId = $(this).data("userid");
            let siteId = $(this).data("siteid");
            Swal.fire({
                title: "Are you sure?",
                html: "You want to approve site set as primary request",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Yes, approve it!",
                closeOnClickOutside: false,
                allowOutsideClick: false,
            }).then((result) => {
                if (result.isConfirmed) {
                    $(".loading").removeClass("d-none");
                    $.ajax({
                        url: baseUrl + "/admin/users/approve-request-set-site-primary",
                        type: "POST",
                        dataType: "JSON",
                        data: { user_id : userId, site_id : siteId},
                        success: function (response) {
                            $(".loading").addClass("d-none");
                            if (response.status == "success") {
                                edgeCommon.swalSuccess(response.message).then(() => {
                                    window.location.reload();
                                });
                            }
                        },
                        error: function (xhr) {
                            $(".loading").addClass("d-none");
                            let err = eval("(" + xhr.responseText + ")");
                            edgeCommon.swalError(err.message);
                        },
                    });
                }
            });
        });
        
    };

    return {
        // public functions
        init: function () {
            initSites();
        },
    };
})();

$(document).ready(function () {
    sites.init();
});
